<i class="fa" [ngClass]="getClasses()"></i>
